<!-- Page Wrapper -->
<div class="page-wrapper" style="min-height: 347px;">
  <div class="content container-fluid">
      <div class="bg-white page-border">
          <!--page body contant -->
          <!-- header  -->
          <div class="row row-replace add-m-b">
              <div class="col-md-6 col-9 col-p h5"><i class="fa fa-suitcase"></i> MRF / JOINING DETAILS</div>
              <div class="col-md-6 col-3 top-corner-items col-p">
                  <button class="btn btn-primary btn-sm"><i class="fa fa-arrow-left"></i> Back</button>
              </div>
          </div>
          <div class="row">
              <div class="col-md-4">
                  <div class="form-group" >
                      <label for="org_names1">Search By</label>
                      <select id="org_names1" class="form-control" (change)="searchBy($event)">
                          <option value="">Select....</option>
                          <option value="site">Site Wise</option>
                          <option value="cand" >Candidate Wise</option>
                          <option value="emp" >Emp Type</option>
                      </select>
                  </div>
              </div>
              <div class="col-md-4">
                  <div class="form-group" *ngIf="searchTerm === 'site'">
                      <label for="org_names11">Select Site</label>
                      <select id="org_names11" class="form-control">
                          <option value="">Select....</option>
                      </select>
                  </div>
                  <div class="form-group" *ngIf="searchTerm === 'cand'">
                      <label for="org_names11">Select Candidate</label>
                      <select id="org_names11" class="form-control">
                          <option value="">Select....</option>
                      </select>
                  </div>
                  <div class="form-group" *ngIf="searchTerm === 'emp'">
                      <label for="org_names111">Select Employee</label>
                      <select id="org_names111" class="form-control">
                          <option value="">Select....</option>
                      </select>
                  </div>
              </div>
          </div>

          <div class="row row-replace" >
              <div class="col-12 col-pn">
                  <div class="card card-table flex-fill">
                      <div class="row pagination-padding">
                        <div class="col-md-9 form-inline">
                          <label for="itemperpage">Items Per Page</label>
                          <select name="itemperpage" id="itemperpage" class="form-control ml-10">
                                            <option value="5">5</option>
                                            <option value="10">10</option>
                                            <option value="20">20</option>
                                            <option value="50">50</option>
                          </select>
                        </div>
                      </div>
                      <div class="card-body">
                          <div class="example-table-container table-responsive">
                              <div class="table-responsive">
                                  <table class="table custom-table mb-0">
                                      <thead>
                                          <tr>
                                              <th>Photo</th>
                                              <th>MRF ID</th>
                                              <th>Cand ID</th>
                                              <th>Emp ID</th>
                                              <th>Name</th>
                                              <th>Emp Type</th>
                                              <th>Skill Category</th>
                                              <th>MRF Type</th>
                                              <!-- <th>Org DOJ</th>
                                              -->
                                              <th>Date of joining</th>
                                              <th>Next Steps</th>
                                              <th>Checklist</th>
                                          </tr>
                                      </thead>
                                      <tbody>
                                          <tr *ngFor="let item of joiniesList;">
                                              <td>IMG</td>
                                              <td> {{item.mrf_code}} </td>
                                              <td> {{item.cand_code}} </td>
                                              <td> {{item.empID}} </td>
                                              <td> {{item.cand_name}}  {{item.cand_last_name}} </td>
                                              <td *ngIf="item.is_transfer_ == 0">{{item.mrf_emp_cate}}</td>
                                              <td *ngIf="item.is_transfer_ == 0">{{item.mrf_skill}}</td>
                                              <td *ngIf="item.is_transfer_ == 1">{{item.emp_mrf_emp_cate}}</td>
                                              <td *ngIf="item.is_transfer_ == 1">{{item.emp_mrf_skill}}</td>


                                              <td> {{item.mrfType}} </td>
                                              <td *ngIf="item.is_transfer_ == 0">{{item.doj}}</td>
                                              <td *ngIf="item.is_transfer_ == 1">{{item.reqd_by}}</td>
                                              <!-- <td></td>
                                              <td></td> -->
                                              <td class="mw-303">
                                                  <div class="btn-group btn-group-sm d-block">
                                                      <button type="button" class="btn btn-sm btn-success" *ngIf="item.is_transfer_ == 0" (click)="addCandJoin(item.cand_id)" ><i class="fa fa-user-plus" aria-hidden="true"></i> Onboard</button>
                                                      <button type="button" class="btn btn-sm btn-success" *ngIf="item.is_transfer_ == 1" (click)="addEmpJoin(item.cand_id)" ><i class="fa fa-user-plus" aria-hidden="true"></i> Onboard</button>
                                                      <button type="button"  class="btn btn-sm btn-danger" (click)="rejectUser(item.cand_id)"  ><i class="fa fa-user-times" aria-hidden="true"></i> Reject</button>
                                                      <button type="button" class="btn btn-sm btn-warning" (click)="openModal('#extend_warrnty')"><i class="fa fa-user-plus" aria-hidden="true"></i> Extend Joining</button>
                                                  </div>
                                              </td>
                                              <td><a (click)="openModal('#on_board')"> Pending</a></td>
                                          </tr>
                                      </tbody>
                                  </table>
                                </div>
                              </div>
                            </div>
                  </div>
              </div>
          </div>
  </div>
</div>


<div id="on_board" class="modal  custom-modal fade" data-backdrop="static"  role="dialog">
  <div class="modal-dialog   modal-dialog-centered modal-xl" role="document">
     <div class="modal-content">
        <div class="modal-header">
           <h5 class="modal-title" id="zero_country_form_title">Candidate Joining</h5>
           <button type="button" class="close" data-dismiss="modal" aria-label="Close">
           <span aria-hidden="true">&times;</span>
           </button>
        </div>

        <div class="row">
          <div class="col-md-12">
        <div class="table-responsive">
          <table class="table custom-table mb-0">
              <thead>
                  <tr>
                      <th>S NO.</th>
                      <th>Checklist</th>
                      <th>Status</th>
                      <th>Action</th>
                  </tr>
              </thead>
              <tbody>
                  <tr>
                      <td>1</td>
                      <td>Bank Details Updated</td>
                      <td>
                              <div class="form-check form-check-inline">
                                 <input class="form-check-input" name="bank" type="radio" value="1">
                                 <label class="form-check-label" for="">Yes</label>
                              </div>
                              <div class="form-check form-check-inline">
                                 <input class="form-check-input" name="bank" type="radio" value="0">
                                 <label class="form-check-label" for="">No</label>
                              </div>
                      </td>
                      <td>No Action Required</td>
                  </tr>
                  <tr>
                      <td>2</td>
                      <td>Id Card Request</td>
                      <td>
                              <div class="form-check form-check-inline">
                                 <input class="form-check-input" name="idCard" type="radio" value="1">
                                 <label class="form-check-label" for="">Yes</label>
                              </div>
                              <div class="form-check form-check-inline">
                                 <input class="form-check-input" name="idCard" type="radio" value="0">
                                 <label class="form-check-label" for="">No</label>
                              </div>
                      </td>
                      <td>No Action Required</td>
                  </tr>
                  <tr>
                      <td>3</td>
                      <td>Safety Jacket</td>
                      <td>
                              <div class="form-check form-check-inline">
                                 <input class="form-check-input" name="jacket" type="radio" value="1">
                                 <label class="form-check-label" for="">Yes</label>
                              </div>
                              <div class="form-check form-check-inline">
                                 <input class="form-check-input" name="jacket" type="radio" value="0">
                                 <label class="form-check-label" for="">No</label>
                              </div>
                      </td>
                      <td>No Action Required</td>
                  </tr>
                  <tr>
                      <td>4</td>
                      <td>Shoes</td>
                      <td>
                              <div class="form-check form-check-inline">
                                 <input class="form-check-input" name="Shoes" type="radio" value="1">
                                 <label class="form-check-label" for="">Yes</label>
                              </div>
                              <div class="form-check form-check-inline">
                                 <input class="form-check-input" name="Shoes" type="radio" value="0">
                                 <label class="form-check-label" for="">No</label>
                              </div>
                      </td>
                      <td>No Action Required</td>
                  </tr>
                  <tr>
                      <td>5</td>
                      <td>Dress</td>
                      <td>
                              <div class="form-check form-check-inline">
                                 <input class="form-check-input" name="dress" type="radio" value="1">
                                 <label class="form-check-label" for="">Yes</label>
                              </div>
                              <div class="form-check form-check-inline">
                                 <input class="form-check-input" name="dress" type="radio" value="0">
                                 <label class="form-check-label" for="">No</label>
                              </div>
                      </td>
                      <td>No Action Required</td>
                  </tr>
              </tbody>
          </table>
        </div>
        </div>
        </div>
     </div>
  </div>
</div>


<div id="extend_warrnty" class="modal  custom-modal fade" data-backdrop="static"  role="dialog">
  <div class="modal-dialog   modal-dialog-centered modal-lg" role="document">
     <div class="modal-content">
        <div class="modal-header">
           <h5 class="modal-title" id="zero_country_form_title">Extend Joining</h5>
           <button type="button" class="close" data-dismiss="modal" aria-label="Close">
           <span aria-hidden="true">&times;</span>
           </button>
        </div>

        <!-- <form [formGroup]="extendJoin"> -->
          <div class="modal-body">
              <div class="row">
                  <div class="col-md-3"></div>
                    <div class="col-md-6">
                      <div class="form-group">
                          <label for="">Select Date<span class="text-danger">*</span></label>
                          <input type="date" class="form-control">
                      </div>
                  </div>
                  <div class="col-md-3"></div>

                </div>
          </div>
          <div class="modal-footer">
              <button type="submit" class="btn btn-primary btn-sm "><i class="fa fa-save"></i> SAVE</button>
              <button type="button" class="btn btn-danger btn-sm"  data-dismiss="modal">Close</button>
          </div>
      <!-- </form>  -->

     </div>
  </div>
</div>


